export const api = {
  GET_LIST_BY_FIRM: '/inspections/getListByFirm',
};
